import React from 'react';

const TabContent = ({ children }) => (
  <div style={{ display: 'flex', width: '100%', marginTop: 10 }}>
    {children}
  </div>
);

export default TabContent;
